import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AgencyHistory() {
  const titleRef = useScrollAnimation();
  const contentRef = useScrollAnimation();

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 
              ref={titleRef.ref}
              className={`text-4xl md:text-5xl font-serif font-bold text-primary mb-6 transition-all duration-1000 ${
                titleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Our Story
            </h2>
            <div 
              ref={contentRef.ref}
              className={`space-y-4 text-gray-700 transition-all duration-1000 delay-200 ${
                contentRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <p className="text-lg leading-relaxed">
                Dallas Health Insurance Experts was founded with a simple mission: to help individuals, families, and businesses in Dallas find the right health insurance coverage at the best possible rates.
              </p>
              <p className="text-lg leading-relaxed">
                With over 15 years of experience in the health insurance industry, we've helped thousands of clients navigate the complex world of health insurance. As an independent agency, we work with over 20 top-rated insurance carriers, giving you access to a wide range of plans and pricing options.
              </p>
              <p className="text-lg leading-relaxed">
                Our team of licensed insurance professionals is dedicated to providing personalized service, expert guidance, and ongoing support. We take the time to understand your unique needs and budget, then help you find coverage that provides the protection you need at a price you can afford.
              </p>
            </div>
          </div>

          <div className="relative h-[500px] rounded-lg overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/3a0cf248d12c726bbd7c0272ee1eed26.jpg"
              alt="Dallas Health Insurance Experts Team"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="bg-gray-50 rounded-lg p-8 text-center">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-primary mb-2">Our Mission</h3>
            <p className="text-gray-700">
              To provide accessible, affordable health insurance solutions while delivering exceptional customer service and expert guidance.
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-8 text-center">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-eye-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-primary mb-2">Our Vision</h3>
            <p className="text-gray-700">
              To be Dallas's most trusted health insurance agency, known for integrity, expertise, and unwavering commitment to our clients.
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-8 text-center">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-primary mb-2">Our Values</h3>
            <p className="text-gray-700">
              Integrity, transparency, client-first service, expert knowledge, and building lasting relationships with every client we serve.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
